<!--
 * @Date: 2024-02-22 14:33:11
 * @LastEditors: lidya lidya 1612405095@qq.com
 * @LastEditTime: 2025-04-24 14:40:11
 * @FilePath: /quiz/src/App.vue
-->
<template>
	<el-config-provider :locale="zhCn">
		<router-view />
	</el-config-provider>
	<footer>
		<div class="cs-footer">
			
			<div class="footer-desc-text"> <h4>
                Do you want to find a place to relax, laugh, and discover your uniqueness? Welcome to bookhockey, your new happy world on the Internet  We are committed to transforming your leisure time (or rather a few hours, we won't judge) into pure entertainment. Whether you're enjoying it alone, with friends, or struggling, bookhockey offers a wealth of quizzes, games, photo magic, and endless fun to keep you entertained  There is no boring content. There are no complex rules. Only the endless fun that makes you unable to resist wanting to screenshot and share  What is bookhockey about? We have created bookhockey for people like you - dreamers, gamers, movie fans, and avid fans of 'I'll take the test again'  Imagine it as your playground, where creativity, randomness, and pure chaos (the fun kind) collide and collide. Guess what? You don't even need to think too much. Just immerse yourself in it and let the beautiful atmosphere find you 
            </h4></div>
			<div class="cs-footer-about">  <router-link to="/termsofuse">Terms of Use</router-link>
				<router-link to="/contactus">Contact us</router-link>
				<router-link to="/privacy">Privacy Policy</router-link>
				</div>
		</div>
	</footer>
</template>

<script setup lang="ts">
	import {
		ElConfigProvider
	} from 'element-plus';
	import zhCn from 'element-plus/es/locale/lang/zh-cn';
</script>
<style>
	@import './assets/css/main.css';
	@import './assets/css/color-dark.scss';
</style>
<style>

.footer-desc-text {
    margin-top: 2em;
    margin-bottom: 1em;
    font-size: 1.2em;
    font-family: Arial;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 1.6em;
    text-align: center;
}
footer {
    width: 100%;
    background-color: var(--foot-color);
    padding-block: 15px;
    margin-top: 20px;
}

.cs-footer {
    margin: 0 auto;
    max-width: 1200px;
}

.cs-footer-introduction {
    font-size: 14px;
    /* font-family: Bahnschrift; */
    font-weight: 400;
    color: #FAFEFF;
    margin-top: 25px;
    padding-bottom: 15px;
    border-bottom: 2px solid #5AB8FF;
}

.cs-footer-about {
    display: flex
;
    justify-content: space-around;
    margin-top: 12px;
    flex-wrap: wrap;
}

.cs-footer-about a {
    display: block;
	color: white;
}

.cs-footer-about a span {
    height: 21px;
    font-size: 14px;
    /* font-family: Bahnschrift; */
    font-weight: 400;
    color: #FAFEFF;
}
</style>